"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _react = _interopRequireDefault(require("react"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _UrlHelper = _interopRequireDefault(require("../../../helpers/UrlHelper"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var HomeCordova = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(HomeCordova, _Kesi2BasicComponent);

  var _super = _createSuper(HomeCordova);

  function HomeCordova(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, HomeCordova);
    _this = _super.call(this, props, context);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "refreshContent", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _promise["default"].resolve());

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = _objectSpread({
      error: null
    }, _this.state); // PLEASE !!!, Don't use regexp

    var params = _UrlHelper["default"].parseURL(window.location.search);

    var id = params.spocId ? params.spocId : null;

    if (id) {
      _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(id));
    } else {
      if (_config["default"].cordovaStartUrl()) {
        _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl(), null, true);
      }
    }

    return _this;
  }
  /*
    componentWillMount() {
       console.log({cordovaStartUrl: target.cordovaStartUrl()});
       if (target.cordovaStartUrl()) {
        NavigationManagerCordova.goTo(target.cordovaStartUrl(), null, true);
      }
    }
    */


  (0, _createClass2["default"])(HomeCordova, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log({
        cordovaStartUrl: _config["default"].cordovaStartUrl()
      });

      if (_config["default"].cordovaStartUrl()) {
        _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl(), null, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Fehler beim Laden der App: ", /*#__PURE__*/_react["default"].createElement("br", null), this.state.error);
      }

      return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
    }
  }]);
  return HomeCordova;
}(_KESI2BasicComponent["default"]);

HomeCordova.propTypes = {// getCourse: PropTypes.func.isRequired,
  // refreshContent: PropTypes.func.isRequired,
};
var _default = HomeCordova;
exports["default"] = _default;